import React, { Component, createRef } from "react";
import { withI18n } from "@lingui/react";
import { connect } from "react-redux";
import SearchActions from 'bukku/redux/Search/actions';
import StyledModal from './style';
import Searchbar from "./Searchbar";
import { SearchGuide } from "./SearchGuide";
import SearchDirectory from "./SearchDirectory";
import { getValidRoutes } from "../helper";
import { createFuseSearch } from "../../../helpers/createFuseSearch";
import { withRouter } from "react-router";
import { Form } from "antd";
import _ from "underscore";
import { createListManager } from "../../../redux/List/helper";
import { L } from "../../../redux/List/reducer";

const {
    readTransactions,
    cacheSearchTerm,
} = SearchActions;

// const fuse = createFuseSearch(fuseOptions, true);
// fuse.setData(getValidRoutes());

class ModalSearch extends Component {
    inputFocusRef = createRef();
    formRef = createRef();
    allValidRoutes = getValidRoutes();
    listManager = createListManager([L.flow_streams]);

    constructor(props) {
        super(props);
        this.state = {
            fuseSearchResults: [],
        };
    }

    componentDidMount() {
        const {
            streamsList,
        } = this.props;
        this.setFuse(streamsList);
    }

    componentDidUpdate(prevProps) {
        const {
            location,
            locale,
            streamsReadAllState,
            // streams,
            streamsList,
            // parent
            visible,
        } = this.props;

        const prevAllValidRoutes = this.allValidRoutes;
        const nextAllValidRoutes = getValidRoutes(streamsList);

        // On visible
        if (visible && !prevProps.visible)
            this.onPageLoad();

        if (prevProps.location.pathname !== location.pathname)
            this.clearAndCloseModal();

        if (
            (prevProps.locale === 'en' && locale !== 'en') ||
             (prevProps.locale !== 'en' && locale === 'en') ||
             (!_.isEqual(streamsList, prevProps.streamsList) && streamsReadAllState === 'success')
        )
            this.setFuse(streamsList);

        // Workaround for locale change but t`` not changed in getValidRoutes
        if (!_.isEqual(prevAllValidRoutes, nextAllValidRoutes)) {
            // console.log('aaa globalSearch allValidRoutes changed');
            const newAllValidRoutes = getValidRoutes(streamsList);
            this.allValidRoutes = newAllValidRoutes;
            this.setFuse(streamsList);
        }
    }

    setFuse = streamsList => {
        const {
            locale,
        } = this.props;

        // fusejs for fuzzy search
        const fuseOptions = {
            includeScore: true,
            threshold: 0.3,
            includeMatches: true,
            keys: [
                { name: "parentLabel", weight: 3},
                { name: "label", weight: 5 },
                { name: "globalSearchKeywords.searchLabel", weight: 2 },
                ...(locale !== 'en' ? [{ name: "globalSearchBaseLabel", weight: 4 }] : []),
            ],
        };
        this.fuse = createFuseSearch(fuseOptions, true);
        this.fuse.setData(getValidRoutes(streamsList));
        // this.fuse.setData(this.allValidRoutes);
    };

    onPageLoad = () => {
        const {
            // readAllStreams,
            searchTerm,
        } = this.props;

        // readAllStreams();
        this.listManager.readLists();
        setTimeout(() => {
            if (searchTerm) {
                this.setSearchTerm(searchTerm);
                this.formRef.current?.setFieldsValue({
                    global_search_input: searchTerm,
                });
            }
            // this.inputFocusRef.current.focus();
            this.inputFocusRef.current.select();
        }, 50);
    };

    setSearchTerm = searchTerm => {
        const {
            // redux
            cacheSearchTerm,
        } = this.props;

        // this.setState({ searchTerm });
        cacheSearchTerm(searchTerm);
        // this.formRef.current?.setFieldsValue({
        //     global_search_input: searchTerm,
        // });
        if (!searchTerm) {
            this.setState({ fuseSearchResults: [] });
            return;
        }

        const fuseResults = this.fuse.search(searchTerm);
        this.setState({ fuseSearchResults: fuseResults });
    };

    clearAndCloseModal = () => {
        const {
            // parent
            handleCancel,
        } = this.props;
        handleCancel();
        this.setSearchTerm(null);
    };

    render() {
        const {
            // parent
            visible,
            handleCancel,
            // redux
            searchTerm,
        } = this.props;
        const {
            fuseSearchResults,
        } = this.state;

        return (
            <StyledModal
                open={visible}
                onOk={handleCancel}
                onCancel={handleCancel}
                footer={null}
                closable={false}
                width={520}
                zIndex={1001}
                destroyOnClose
            >
                <Form
                    ref={this.formRef}
                >
                    <Searchbar
                        setSearchTerm={this.setSearchTerm}
                        inputRef={this.inputFocusRef}
                        focusedTab={searchTerm ? 'result' : 'guide'}
                    />
                </Form>
                <div>
                    <SearchGuide
                        visible={!searchTerm}
                    />
                    <SearchDirectory
                        visible={searchTerm}
                        searchResults={fuseSearchResults}
                        clearAndCloseModal={this.clearAndCloseModal}
                    />
                </div>
            </StyledModal>
        );
    }
}

export default withRouter(connect(state => ({
    view: state.App.view,
    transactions: state.Search.transactions,
    transactionReadAllState: state.Search.transactionReadAllState,
    searchTerm: state.Search.searchTerm,
    locale: state.App.locale,
    streams: state.Flow.streams,
    streamsReadAllState: state.Flow.streamsReadAllState,
    streamsList: state.List.flowStreams,
}), {
    readTransactions,
    // readAllStreams,
    cacheSearchTerm,
})(withI18n()(ModalSearch)));
